import React from "react";

const MobileAppSection = () => {
  return (
    <section className="py-24 bg-white text-slate-800 relative overflow-hidden">
      {/* GRADIANT EFFET*/}
      <div className="absolute top-0 right-0 w-1/2 h-full bg-gradient-to-l from-cyan-50/50 to-transparent -z-10"></div>

      <div className="container mx-auto px-6 max-w-screen-xl">
        <div className="text-start max-w-4xl mb-20">
          <div className="flex items-center gap-3 mb-4">
            <span className="px-3 py-1 rounded-full bg-blue-700 text-white text-xs font-bold uppercase tracking-wider border border-cyan-200">
              Powered by Flutter
            </span>
            <span className="text-slate-400 text-sm">•</span>
            <span className="text-slate-500 text-sm">iOS & Android</span>
          </div>

          <h2 className="text-4xl md:text-6xl font-bold mb-6 text-slate-900 leading-tight">
            One Codebase, <br />
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-cyan-500 to-blue-600">
              Limitless Platforms
            </span>
          </h2>

          <p className="text-lg text-slate-600 leading-relaxed max-w-2xl">
            We utilize the power of <strong>Flutter</strong> to build natively
            compiled applications for mobile, web, and desktop from a single
            codebase. Experience fast development, expressive UI, and native
            performance on every device.
          </p>
        </div>

        {/* GRID CARDS*/}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10">
          {/*CARD 1 Cross-Platform */}
          <div className="bg-white p-10 rounded-3xl shadow-xl border border-slate-100 hover:border-cyan-200 hover:shadow-cyan-100/50 transition-all duration-500 group relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-cyan-400 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            <div className="w-16 h-16 bg-cyan-50 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300">
              <svg
                className="w-8 h-8 text-cyan-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M12 18h.01M8 21h8a2 2 0 002-2V5a2 2 0 00-2-2H8a2 2 0 00-2 2v14a2 2 0 002 2z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold mb-3 text-slate-900">
              Cross-Platform Core
            </h3>
            <p className="text-slate-500 leading-relaxed">
              Target iOS, Android, Web, and Desktop simultaneously without
              compromising quality. Save time and resources with a unified
              codebase.
            </p>
          </div>

          {/* CARD 2 Native Performance */}
          <div className="bg-white p-10 rounded-3xl shadow-xl border border-slate-100 hover:border-cyan-200 hover:shadow-cyan-100/50 transition-all duration-500 group relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-cyan-400 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            <div className="w-16 h-16 bg-cyan-50 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300">
              <svg
                className="w-8 h-8 text-cyan-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M13 10V3L4 14h7v7l9-11h-7z"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold mb-3 text-slate-900">
              Native Performance
            </h3>
            <p className="text-slate-500 leading-relaxed">
              Flutter compiles to native ARM code, ensuring your app runs
              smoothly at 60fps or 120fps on any device, just like a true native
              app.
            </p>
          </div>

          {/* CARD 3 Custom UI */}
          <div className="bg-white p-10 rounded-3xl shadow-xl border border-slate-100 hover:border-cyan-200 hover:shadow-cyan-100/50 transition-all duration-500 group relative overflow-hidden">
            <div className="absolute top-0 left-0 w-1 h-full bg-gradient-to-b from-cyan-400 to-blue-600 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>

            <div className="w-16 h-16 bg-cyan-50 rounded-2xl flex items-center justify-center mb-8 group-hover:scale-110 transition-transform duration-300">
              <svg
                className="w-8 h-8 text-cyan-600"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M7 21a4 4 0 01-4-4V5a2 2 0 012-2h4a2 2 0 012 2v12a4 4 0 01-4 4zm0 0h12a2 2 0 002-2v-4a2 2 0 00-2-2h-2.343M11 7.343l1.657-1.657a2 2 0 012.828 0l2.829 2.829a2 2 0 010 2.828l-8.486 8.485M7 17h.01"
                />
              </svg>
            </div>
            <h3 className="text-2xl font-bold mb-3 text-slate-900">
              Pixel-Perfect UI
            </h3>
            <p className="text-slate-500 leading-relaxed">
              Create stunning, customized user interfaces with control over
              every pixel. Flutter's layered architecture allows for fast,
              flexible designs.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MobileAppSection;
